export const DATA_SOURCE_OPTIONS_DOCUMENTATION_LINK =
  'https://docs.stardog.com/virtual-graphs/data-sources/data-source-configuration#configuration-options';
export const DESIGNER_ARTIFACT_DEFINITIONS_LINK =
  'https://docs.stardog.com/stardog-applications/designer/#designer-artifact-definitions';
export const PROJECT_SETTINGS_DOCUMENTATION_LINK =
  'https://docs.stardog.com/stardog-applications/designer/#project-settings';
export const SSL_SETUP_DOCUMENTATION_LINK =
  'https://docs.stardog.com/operating-stardog/security/encryption-in-transit#steps-to-setup-ssl';
export const VIRTUAL_GRAPH_OPTIONS_DOCUMENTATION_LINK =
  'https://docs.stardog.com/virtual-graphs/virtual-graph-configuration#virtual-graph-options';
